import 'timepicker/jquery.timepicker.min';
import 'timepicker/jquery.timepicker.min.css';

// window.$ = window.jQuery = $.jQuery;

function timepicker(elements) {
    $(elements).each((i, el) => {
        $(el).timepicker({
            listWidth: 1,
            timeFormat: 'H:i',
            step: 180,
        });
    });
    $(document).on('timepickerUpdated', function () {
        window.timepickerData.forEach((item) => {
            $(item.element[0]).timepicker('option', {'minTime': item.minTime, 'maxTime': item.maxTime});
            if ($(item.element[0]).val() && $(item.element[0]).val() < item.minTime.slice(0, -3)) {
                $(item.element[0]).timepicker('setTime', item.minTime).trigger('change');
            } else if ($(item.element[0]).val() && $(item.element[0]).val() > item.maxTime.slice(0, -3)) {
                $(item.element[0]).timepicker('setTime', item.maxTime).trigger('change');
            }
        });
    });
}

export default function (elements) {
    timepicker(elements);
}